
export enum LicenseEquipmentOwnedLeaseCd {
	LEASE = 'Lease',
	OWNED = 'Owned'}

